import React, { useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { SelectForm } from '../Basicos';
import { CardCrud } from '../Conteudo/Cards/index';
import * as actionsRedux from '../Store/Actions/index';

const OPCAO_TODOS = { label: 'Todos', value: '' };

// Cada linha listada pelo CardCrud já é uma janela (período letivo + semestre). Esse componente só
// adiciona os dois selects de filtro em cima dela, numa linha cheia abaixo do título — mesmo
// padrão visual/estrutura da barra de filtro de "Visualizar Semana - Sintética" (SelectForm +
// Row + botões Pesquisar/Limpar) — e reaproveita o CardCrud (criar/editar/remover/paginação)
// trocando só o "dados" que ele recebe pelo subconjunto filtrado.
export default function CampanhaVacinacao(props) {
    const { subFuncionalidade, funcionalidade, indiceSubFuncionalidade } = props;
    const dadosOriginais = subFuncionalidade.dados || [];
    const dispatch = useDispatch();

    // O "Novo" some da posição padrão do CardCrud (ao lado do título) e passa a ficar na mesma
    // linha do filtro — mesmo dispatch que o CardCrud usaria por baixo dos panos.
    const abrirNovo = () => dispatch(actionsRedux.ativarModalSubFuncionalidade(funcionalidade, indiceSubFuncionalidade, 'adicionar'));

    const [periodoLetivoId, setPeriodoLetivoId] = useState('');
    const [semestreId, setSemestreId] = useState('');

    const periodosLetivos = [];
    const periodosVistos = new Set();
    dadosOriginais.forEach((janela) => {
        if (!periodosVistos.has(janela.campanha_vacinacao_id)) {
            periodosVistos.add(janela.campanha_vacinacao_id);
            periodosLetivos.push({ label: janela.descricao, value: janela.campanha_vacinacao_id });
        }
    });
    const periodoLetivoOptions = [OPCAO_TODOS, ...periodosLetivos];

    const semestreOptions = [
        OPCAO_TODOS,
        ...dadosOriginais
            .filter((janela) => !periodoLetivoId || String(janela.campanha_vacinacao_id) === String(periodoLetivoId))
            .map((janela) => ({ label: janela.semestre_descricao, value: janela.semestre_id })),
    ];

    const onChangeSelect = (nome, valor) => {
        if (nome === 'periodo_letivo_id') {
            setPeriodoLetivoId(valor);
            setSemestreId('');
        } else if (nome === 'semestre_id') {
            setSemestreId(valor);
        }
    };

    const limparFiltro = () => {
        setPeriodoLetivoId('');
        setSemestreId('');
    };

    const dadosFiltrados = dadosOriginais.filter((janela) => (
        (!periodoLetivoId || String(janela.campanha_vacinacao_id) === String(periodoLetivoId))
        && (!semestreId || String(janela.semestre_id) === String(semestreId))
    ));

    // "Pesquisar" não dispara nenhuma busca nova — a lista já é filtrada na hora, a cada troca de
    // select. Fica só por consistência visual com o mesmo padrão usado nas telas de agenda.
    const filtros = (
        <Col sm={12} md={12}>
            <Row className="pr-5 px-3">
                <SelectForm
                    telaAgenda
                    label="Período Letivo"
                    name="periodo_letivo_id"
                    placeholder="Todos"
                    options={periodoLetivoOptions}
                    value={periodoLetivoOptions.find((opcao) => String(opcao.value) === String(periodoLetivoId)) ?? OPCAO_TODOS}
                    onChange={onChangeSelect}
                    style={{ col: { sm: 2, xs: 4, md: 3, lg: 2, xl: 2 } }}
                />
                <SelectForm
                    telaAgenda
                    label="Semestre"
                    name="semestre_id"
                    placeholder="Todos"
                    options={semestreOptions}
                    value={semestreOptions.find((opcao) => String(opcao.value) === String(semestreId)) ?? OPCAO_TODOS}
                    onChange={onChangeSelect}
                    style={{ col: { sm: 2, xs: 4, md: 3, lg: 2, xl: 2 } }}
                />
                <Col xs="auto" className="btn-limpar-filtro-agenda">
                    <Button className="mx-3 py-2 pesquisar-agenda" onClick={() => {}}>Pesquisar</Button>
                </Col>
                <Col xs="auto" className="btn-limpar-filtro-agenda">
                    <Button className="mx-3 py-2 pesquisar-agenda" onClick={limparFiltro}>Limpar</Button>
                </Col>
                {subFuncionalidade.acoes?.criar && (
                    <Col xs="auto" className="btn-limpar-filtro-agenda">
                        <Button className="mx-3 py-2 pesquisar-agenda" onClick={abrirNovo}>Novo</Button>
                    </Col>
                )}
            </Row>
        </Col>
    );

    return (
        <CardCrud
            {...props}
            pesquisaGlobal={false}
            filtrosExtras={filtros}
            subFuncionalidade={{ ...subFuncionalidade, dados: dadosFiltrados, acoes: { ...subFuncionalidade.acoes, criar: false } }}
        />
    );
}
